var Ft = Object.defineProperty;
var tt = (t) => {
  throw TypeError(t);
};
var zt = (t, n, s) => n in t ? Ft(t, n, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[n] = s;
var J = (t, n, s) => zt(t, typeof n != "symbol" ? n + "" : n, s), Mt = (t, n, s) => n.has(t) || tt("Cannot " + s);
var pe = (t, n, s) => (Mt(t, n, "read from private field"), s ? s.call(t) : n.get(t)), he = (t, n, s) => n.has(t) ? tt("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(t) : n.set(t, s);
import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import { ChevronRightIcon as Q, CheckIcon as Ht, DotIcon as _t, Check as Bt, XIcon as Gt, Circle as Jt, ChevronDownIcon as Ut, InfoIcon as nt, LogInIcon as Qt, CirclePlayIcon as Wt } from "lucide-react";
import { r as Zt, m as st } from "./chunk-BAXFHI7N-BVBOl9s0.js";
import { p as xt, q as gt, r as Xt, m as Kt, t as Yt, f as R, l as en } from "./hook-CldJlP5c.js";
import { Button as W } from "./ui/Button.js";
import { Z as tn } from "./invariant-Caa8-XvF.js";
import { VisuallyHidden as nn } from "@radix-ui/react-visually-hidden";
import * as b from "react";
import { Fragment as q, useRef as G, useEffect as ne, useMemo as sn, useState as k, useCallback as an, useTransition as rn } from "react";
import { D as Pe, a as ke, b as Ie, d as ft, e as yt, f as on } from "./Dialog-ByYz4ABw.js";
import { S as je, a as be, b as Ne, c as we, e as U, u as ln } from "./Select-CT64Ou40.js";
import { b as Re, u as Oe, C as L, a as cn, F as dn } from "./index.esm-D2ZUREQN.js";
import { c as vt } from "./index-CPNSgwSb.js";
import { c as g } from "./cn-qaFjX9_3.js";
import { Tabs as jt, TabsList as bt, TabsTrigger as M, TabsContent as H } from "./ui/Tabs.js";
import { o as mn } from "./objectEntries-yMIkr2mI.js";
import { u as un } from "./useLatest-hmRS46UF.js";
import { z as pn } from "./index-DwT-v3zK.js";
import { B as A } from "./Button-BBNrKpQd.js";
import * as j from "@radix-ui/react-dropdown-menu";
import { C as le } from "./Card-BtheiD7j.js";
import * as Ce from "@radix-ui/react-checkbox";
import * as se from "@radix-ui/react-popover";
import { PopoverAnchor as hn } from "@radix-ui/react-popover";
import { P as xn } from "./index-CuBIgTKC.js";
import { g as gn, h as fn, C as yn, b as vn, f as jn } from "./Callout-D3Ja4OPX.js";
import { Input as qe } from "./ui/Input.js";
import { Slot as bn } from "@radix-ui/react-slot";
import * as Nt from "@radix-ui/react-label";
import * as Z from "@radix-ui/react-radio-group";
import { S as Nn } from "./Spinner-mNLZ6awP.js";
import { Callout as wn } from "./ui/Callout.js";
import { Card as wt, CardHeader as Cn, CardTitle as Sn, CardContent as Tn } from "./ui/Card.js";
import { Collapsible as at, CollapsibleTrigger as rt, CollapsibleContent as ot } from "./ui/Collapsible.js";
import * as Le from "@radix-ui/react-collapsible";
import { S as $n } from "./SyntaxHighlight-CxhyyMkF.js";
let xe;
const Pn = (t) => {
  var n;
  if ((n = t.errors) != null && n[0])
    throw new tn(t.errors[0].message, {
      developerHint: "Check your configuration value `apis.type` and `apis.input` in the Zudoku config."
    });
};
var oe, ie;
class kn {
  constructor(n) {
    he(this, oe, async () => (xe || (xe = import("./createServer-IW7v5hWm.js").then(
      (n) => n.createServer(this.config)
    )), xe));
    he(this, ie, async (n) => this.config.server ? fetch(this.config.server, n) : (await pe(this, oe).call(this)).fetch("http://localhost/graphql", n));
    J(this, "fetch", async (n, s) => {
      var l;
      const a = (l = n.match(/query (\w+)/)) == null ? void 0 : l[1], r = await pe(this, ie).call(this, {
        method: "POST",
        body: JSON.stringify({ query: n, variables: s, operationName: a }),
        headers: { "Content-Type": "application/json" }
      });
      if (!r.ok)
        throw new Error("Network response was not ok");
      const i = await r.json();
      return Pn(i), i.data;
    });
    this.config = n;
  }
}
oe = new WeakMap(), ie = new WeakMap();
class D extends String {
  constructor(s, a) {
    super(s);
    J(this, "__apiType");
    J(this, "value");
    J(this, "__meta__");
    this.value = s, this.__meta__ = a;
  }
  toString() {
    return this.value;
  }
}
const In = new D(
  `
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}
    `,
  { fragmentName: "OperationsFragment" }
), Rn = new D(`
    query ServersQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), On = new D(`
    query SchemaWarmup($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    openapi
  }
}
    `), qn = new D(`
    query OperationsForTag($input: JSON!, $type: SchemaType!, $tag: String, $untagged: Boolean) {
  schema(input: $input, type: $type) {
    servers {
      url
    }
    description
    summary
    title
    url
    version
    tag(slug: $tag, untagged: $untagged) {
      name
      description
      operations {
        slug
        ...OperationsFragment
      }
      next {
        name
        slug
      }
      prev {
        name
        slug
      }
    }
  }
}
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  deprecated
  extensions
  parameters {
    name
    in
    description
    required
    schema
    style
    explode
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}`), Ln = new D(`
    query GetSchemas($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    title
    description
    summary
    components {
      schemas {
        name
        schema
        extensions
      }
    }
  }
}
    `), An = new D(`
    query getServerQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), En = new D(`
    query GetSidebarOperations($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    tags {
      slug
      name
      extensions
      operations {
        summary
        slug
        method
        operationId
        path
      }
    }
    components {
      schemas {
        __typename
      }
    }
  }
}
    `), Dn = {
  "\n  query ServersQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": Rn,
  "\n  fragment OperationsFragment on OperationItem {\n    slug\n    summary\n    method\n    description\n    operationId\n    contentTypes\n    path\n    deprecated\n    extensions\n    parameters {\n      name\n      in\n      description\n      required\n      schema\n      style\n      explode\n      examples {\n        name\n        description\n        externalValue\n        value\n        summary\n      }\n    }\n    requestBody {\n      content {\n        mediaType\n        encoding {\n          name\n        }\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        schema\n      }\n      description\n      required\n    }\n    responses {\n      statusCode\n      links\n      description\n      content {\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        mediaType\n        encoding {\n          name\n        }\n        schema\n      }\n    }\n  }\n": In,
  "\n  query SchemaWarmup($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      openapi\n    }\n  }\n": On,
  "\n  query OperationsForTag(\n    $input: JSON!\n    $type: SchemaType!\n    $tag: String\n    $untagged: Boolean\n  ) {\n    schema(input: $input, type: $type) {\n      servers {\n        url\n      }\n      description\n      summary\n      title\n      url\n      version\n      tag(slug: $tag, untagged: $untagged) {\n        name\n        description\n        operations {\n          slug\n          ...OperationsFragment\n        }\n        next {\n          name\n          slug\n        }\n        prev {\n          name\n          slug\n        }\n      }\n    }\n  }\n": qn,
  "\n  query GetSchemas($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      title\n      description\n      summary\n      components {\n        schemas {\n          name\n          schema\n          extensions\n        }\n      }\n    }\n  }\n": Ln,
  "\n  query getServerQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": An,
  "\n  query GetSidebarOperations($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      tags {\n        slug\n        name\n        extensions\n        operations {\n          summary\n          slug\n          method\n          operationId\n          path\n        }\n      }\n      components {\n        schemas {\n          __typename\n        }\n      }\n    }\n  }\n": En
};
function Vn(t) {
  return Dn[t] ?? {};
}
const Fn = vt(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Se = b.forwardRef(({ className: t, variant: n, ...s }, a) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: a,
    role: "alert",
    className: g(Fn({ variant: n }), t),
    ...s
  }
));
Se.displayName = "Alert";
const Te = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  "h5",
  {
    ref: s,
    className: g("mb-1 font-medium leading-none tracking-tight", t),
    ...n
  }
));
Te.displayName = "AlertTitle";
const $e = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: s,
    className: g("text-sm [&_p]:leading-relaxed", t),
    ...n
  }
));
$e.displayName = "AlertDescription";
const zn = ({
  path: t,
  renderParam: n
}) => {
  let s = 0;
  return t.split("/").map((a, r, i) => {
    const l = Array.from(a.matchAll(/{([^}]+)}/g)), d = [];
    let c = 0;
    return l.forEach((u) => {
      const [x, w] = u;
      if (!w) return;
      const v = u.index;
      v > c && d.push(
        /* @__PURE__ */ e.jsx(q, { children: a.slice(c, v) }, `text-${c}-${v}`)
      ), d.push(
        /* @__PURE__ */ e.jsx(q, { children: n({ name: w, originalValue: x, index: s++ }) }, `param-${w}`)
      ), c = v + x.length;
    }), c < a.length && d.push(
      /* @__PURE__ */ e.jsx(q, { children: a.slice(c) }, `text-${c}-${a.length}`)
    ), // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ e.jsxs(q, { children: [
      d,
      r < i.length - 1 && "/",
      /* @__PURE__ */ e.jsx("wbr", {})
    ] }, `${a}-${r}`);
  });
}, Ct = b.forwardRef(
  ({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
    "textarea",
    {
      className: g(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        t
      ),
      ref: s,
      ...n
    }
  )
);
Ct.displayName = "Textarea";
const ge = (t) => Math.abs(
  isNaN(parseInt(t)) ? t.toLowerCase().charCodeAt(0) - 96 : isNaN(parseInt(t)) ? 0 : parseInt(t)
), fe = (t) => t.length > 1 ? parseInt(t.split("").reduce((n, s) => `${ge(n) + ge(s)}`)) : ge(t), it = (t, n = {}) => {
  const s = (3 * fe(t) + 2 * fe(t) + fe(t)) % 360, { saturation: a = 75, lightness: r = 60 } = n;
  return `${s}deg ${a}% ${r}%`;
}, ye = "data-linked-param", Mn = (t) => {
  const { resolvedTheme: n } = pn();
  return {
    text: it(
      t,
      n === "light" ? { saturation: 95, lightness: 38 } : {}
    ),
    background: it(
      t,
      n === "light" ? { saturation: 85, lightness: 40 } : {}
    )
  };
}, St = ({
  name: t,
  className: n,
  slug: s,
  title: a,
  children: r,
  onClick: i
}) => {
  const l = G(null), d = s == null ? void 0 : s.replace(/[{}]/g, ""), c = t.replace(/[{}]/g, ""), { text: u, background: x } = Mn(c), w = `hsl(${u} / 100%)`, v = `hsl(${x} / 10%)`, p = `hsl(${x} / 50%)`;
  return ne(() => {
    if (!d || !l.current) return;
    const f = () => {
      document.querySelectorAll(`[${ye}="${d}"]`).forEach((h) => {
        h instanceof HTMLElement && (h.dataset.active = "true");
      });
    }, m = () => {
      document.querySelectorAll(`[${ye}="${d}"]`).forEach((h) => {
        h instanceof HTMLElement && (h.dataset.active = "false");
      });
    }, y = l.current;
    return y.addEventListener("mouseenter", f), y.addEventListener("mouseleave", m), () => {
      y.removeEventListener("mouseenter", f), y.removeEventListener("mouseleave", m);
    };
  }, [d]), /* @__PURE__ */ e.jsx(
    "span",
    {
      [ye]: d,
      className: g(
        // This may not contain (inline-)flex or (inline-)block otherwise it breaks the browser's full text search
        "relative transition-all duration-100 rounded-lg",
        "border border-[--border-color] p-0.5 text-[--param-color] bg-[--background-color]",
        "data-[active=true]:border-[--param-color] data-[active=true]:shadow data-[active=true]:bottom-px",
        n
      ),
      title: a,
      suppressHydrationWarning: !0,
      ref: l,
      onClick: i,
      style: {
        "--param-color": w,
        "--border-color": p,
        "--background-color": v
      },
      children: r ?? t
    }
  );
}, Hn = xt()(
  gt(
    (t) => ({
      selectedServer: void 0,
      setSelectedServer: (n) => t({ selectedServer: n })
    }),
    { name: "zudoku-selected-server" }
  )
), _n = (t) => {
  const { selectedServer: n, setSelectedServer: s } = Hn();
  return { selectedServer: sn(
    () => {
      var r;
      return n && t.some((i) => i.url === n) ? n : ((r = t.at(0)) == null ? void 0 : r.url) ?? "";
    },
    [n, t]
  ), setSelectedServer: s };
}, Bn = (t, n, s) => {
  const a = n.replace(/(:\w+|\{\w+})/g, (i) => {
    var c;
    const l = i.replace(/[:{}]/g, "");
    return ((c = s.pathParams.find((u) => u.name === l)) == null ? void 0 : c.value) ?? i;
  }), r = new URL(
    a.replace(/^\//, ""),
    t.endsWith("/") ? t : `${t}/`
  );
  return s.queryParams.filter((i) => i.active).forEach((i) => {
    r.searchParams.set(i.name, i.value);
  }), r;
}, Tt = j.Root, $t = j.Trigger, Gn = j.Group, Jn = b.forwardRef(({ className: t, inset: n, children: s, ...a }, r) => /* @__PURE__ */ e.jsxs(
  j.SubTrigger,
  {
    ref: r,
    className: g(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      n && "pl-8",
      t
    ),
    ...a,
    children: [
      s,
      /* @__PURE__ */ e.jsx(Q, { className: "ml-auto h-4 w-4" })
    ]
  }
));
Jn.displayName = j.SubTrigger.displayName;
const Un = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  j.SubContent,
  {
    ref: s,
    className: g(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...n
  }
));
Un.displayName = j.SubContent.displayName;
const Ae = b.forwardRef(({ className: t, sideOffset: n = 4, ...s }, a) => /* @__PURE__ */ e.jsx(j.Portal, { children: /* @__PURE__ */ e.jsx(
  j.Content,
  {
    ref: a,
    sideOffset: n,
    className: g(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...s
  }
) }));
Ae.displayName = j.Content.displayName;
const Ee = b.forwardRef(({ className: t, inset: n, ...s }, a) => /* @__PURE__ */ e.jsx(
  j.Item,
  {
    ref: a,
    className: g(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      n && "pl-8",
      t
    ),
    ...s
  }
));
Ee.displayName = j.Item.displayName;
const Qn = b.forwardRef(({ className: t, children: n, checked: s, ...a }, r) => /* @__PURE__ */ e.jsxs(
  j.CheckboxItem,
  {
    ref: r,
    className: g(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: s,
    ...a,
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ e.jsx(j.ItemIndicator, { children: /* @__PURE__ */ e.jsx(Ht, { className: "h-4 w-4" }) }) }),
      n
    ]
  }
));
Qn.displayName = j.CheckboxItem.displayName;
const Wn = b.forwardRef(({ className: t, children: n, ...s }, a) => /* @__PURE__ */ e.jsxs(
  j.RadioItem,
  {
    ref: a,
    className: g(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...s,
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ e.jsx(j.ItemIndicator, { children: /* @__PURE__ */ e.jsx(_t, { className: "h-4 w-4 fill-current" }) }) }),
      n
    ]
  }
));
Wn.displayName = j.RadioItem.displayName;
const Pt = b.forwardRef(({ className: t, inset: n, ...s }, a) => /* @__PURE__ */ e.jsx(
  j.Label,
  {
    ref: a,
    className: g(
      "px-2 py-1.5 text-sm font-semibold",
      n && "pl-8",
      t
    ),
    ...s
  }
));
Pt.displayName = j.Label.displayName;
const kt = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  j.Separator,
  {
    ref: s,
    className: g("-mx-1 my-1 h-px bg-muted", t),
    ...n
  }
));
kt.displayName = j.Separator.displayName;
const Zn = ({
  examples: t,
  onSelect: n
}) => /* @__PURE__ */ e.jsxs(Tt, { children: [
  /* @__PURE__ */ e.jsx($t, { asChild: !0, children: /* @__PURE__ */ e.jsx(A, { variant: "outline", children: "Use Example" }) }),
  /* @__PURE__ */ e.jsx(Ae, { className: "max-w-72", children: t.map((s) => {
    var a;
    return /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(Pt, { children: s.mediaType }),
      /* @__PURE__ */ e.jsx(kt, {}),
      /* @__PURE__ */ e.jsx(Gn, { children: (a = s.examples) == null ? void 0 : a.map((r) => /* @__PURE__ */ e.jsx(
        Ee,
        {
          onSelect: () => n(r, s.mediaType),
          children: /* @__PURE__ */ e.jsx(
            "span",
            {
              className: "line-clamp-1",
              title: r.summary ?? r.name,
              children: r.summary ?? r.name
            }
          )
        },
        r.name
      )) })
    ] }, s.mediaType);
  }) })
] }), ce = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  Ce.Root,
  {
    ref: s,
    className: g(
      "peer h-4 w-4 shrink-0 rounded-[min(6px,var(--radius)-4px)] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary",
      "border border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      t
    ),
    ...n,
    children: /* @__PURE__ */ e.jsx(
      Ce.Indicator,
      {
        className: g("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ e.jsx(Bt, { className: "h-4 w-4" })
      }
    )
  }
));
ce.displayName = Ce.Root.displayName;
const Xn = se.Root, It = b.forwardRef(({ className: t, align: n = "center", sideOffset: s = 4, ...a }, r) => /* @__PURE__ */ e.jsx(se.Portal, { children: /* @__PURE__ */ e.jsx(
  se.Content,
  {
    ref: r,
    align: n,
    sideOffset: s,
    className: g(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...a
  }
) }));
It.displayName = se.Content.displayName;
const Kn = ({
  value: t,
  options: n,
  onChange: s,
  className: a,
  placeholder: r = "Enter value",
  onEnterPress: i,
  ref: l
}) => {
  const [d, c] = k(!1), [u, x] = k(!1), w = xn((p) => p.filtered.count), v = G(null);
  return /* @__PURE__ */ e.jsxs(Xn, { open: d, children: [
    /* @__PURE__ */ e.jsx(hn, { children: /* @__PURE__ */ e.jsx(
      fn,
      {
        ref: (p) => {
          v.current = p, typeof l == "function" ? l(p) : l && (l.current = p);
        },
        value: t,
        placeholder: r,
        className: g("h-9 bg-transparent", a),
        onFocus: () => c(!0),
        onBlur: () => {
          u || c(!1);
        },
        onKeyDown: (p) => {
          var f;
          p.key === "Enter" && (c(!1), (f = v.current) == null || f.blur(), i == null || i(p));
        },
        onValueChange: (p) => s(p)
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        onMouseEnter: () => x(!0),
        onMouseLeave: () => x(!1),
        onOpenAutoFocus: (p) => p.preventDefault(),
        className: g("p-0 w-[--radix-popover-trigger-width]", {
          "border-0": w === 0
        }),
        align: "start",
        side: "bottom",
        onWheel: (p) => {
          p.stopPropagation();
        },
        onTouchMove: (p) => {
          p.stopPropagation();
        },
        children: /* @__PURE__ */ e.jsx(yn, { className: "max-h-[140px]", children: n.map((p) => /* @__PURE__ */ e.jsx(
          vn,
          {
            value: p,
            onSelect: (f) => {
              s(f), c(!1);
            },
            className: "cursor-pointer",
            children: p
          },
          p
        )) })
      }
    )
  ] });
}, ae = ({ shouldFilter: t, ...n }) => /* @__PURE__ */ e.jsx(gn, { className: "bg-transparent", shouldFilter: t, children: /* @__PURE__ */ e.jsx(Kn, { ...n }) }), De = (t, n) => {
  const s = b.forwardRef(({ className: a, asChild: r, ...i }, l) => {
    const d = r ? bn : t;
    return b.createElement(d, {
      ...i,
      ref: l,
      className: typeof n == "function" ? n({ className: a }) : g(n, a)
    });
  });
  return s.displayName = `VariantComponent(${t})`, s;
}, Ve = De(
  "div",
  "grid grid-cols-[2fr_3fr] gap-2 items-center"
), Fe = De(
  "div",
  "group hover:bg-accent px-3 grid col-span-full grid-cols-subgrid"
), Yn = Object.freeze([
  "Accept",
  "Accept-Encoding",
  "Accept-Language",
  "Authorization",
  "Cache-Control",
  "Connection",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-Length",
  "Content-Range",
  "Content-Security-Policy",
  "Content-Type",
  "Cookie",
  "Date",
  "ETag",
  "Expires",
  "Host",
  "If-Modified-Since",
  "Location",
  "Origin",
  "Pragma",
  "Referer",
  "Set-Cookie",
  "User-Agent",
  "X-Requested-With"
]), es = ({
  control: t,
  headers: n
}) => {
  const { fields: s, append: a, remove: r } = Re({
    control: t,
    name: "headers"
  }), { setValue: i, watch: l } = Oe(), d = G([]), c = G([]), u = l("headers"), x = an(() => {
    a({ name: "", value: "", active: !1 });
  }, [a]);
  ne(() => {
    u.length === 0 && x();
  }, [u, x]);
  const w = (f) => {
    var m;
    (m = d.current[f]) == null || m.focus();
  }, v = (f) => {
    x(), requestAnimationFrame(() => {
      var m;
      return (m = c.current[f + 1]) == null ? void 0 : m.focus();
    });
  }, p = n.filter((f) => !u.some((m) => m.name === f.name)).map(({ name: f }) => f);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ e.jsx(le, { className: "overflow-hidden", children: /* @__PURE__ */ e.jsx(Ve, { children: s.map((f, m) => {
      const y = n.find(
        (h) => h.name === l(`headers.${m}.name`)
      );
      return /* @__PURE__ */ e.jsxs(Fe, { children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2 ", children: [
          /* @__PURE__ */ e.jsx(
            L,
            {
              control: t,
              name: `headers.${m}.active`,
              render: ({ field: h }) => /* @__PURE__ */ e.jsx(
                ce,
                {
                  id: `headers.${m}.active`,
                  checked: h.value,
                  onCheckedChange: (T) => {
                    h.onChange(T);
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            L,
            {
              control: t,
              name: `headers.${m}.name`,
              render: ({ field: h }) => /* @__PURE__ */ e.jsx(
                ae,
                {
                  ...h,
                  placeholder: "Name",
                  className: "border-0 shadow-none bg-transparent text-xs font-mono",
                  options: [...p, ...Yn],
                  onEnterPress: () => w(m),
                  onChange: (T) => {
                    h.onChange(T), i(`headers.${m}.active`, !0);
                  },
                  ref: (T) => {
                    c.current[m] = T;
                  }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e.jsx(
            L,
            {
              control: t,
              name: `headers.${m}.value`,
              render: ({ field: h }) => (y == null ? void 0 : y.enum) && y.enum.length > 0 ? /* @__PURE__ */ e.jsx(
                ae,
                {
                  shouldFilter: !1,
                  value: h.value,
                  options: y.enum ?? [],
                  onChange: ($) => {
                    h.onChange($), i(`headers.${m}.active`, !0);
                  },
                  className: "font-mono text-xs border-0"
                }
              ) : /* @__PURE__ */ e.jsx(
                qe,
                {
                  placeholder: "Value",
                  className: "w-full border-0 shadow-none text-xs font-mono focus-visible:ring-0",
                  ...h,
                  ref: ($) => {
                    d.current[m] = $;
                  },
                  onKeyDown: ($) => {
                    $.key === "Enter" && $.currentTarget.value.trim() && v(m);
                  },
                  autoComplete: "off"
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            W,
            {
              size: "icon",
              variant: "ghost",
              className: "text-muted-foreground opacity-0 group-hover:opacity-100 rounded-full w-8 h-7",
              onClick: () => r(m),
              type: "button",
              children: /* @__PURE__ */ e.jsx(Gt, { size: 16 })
            }
          )
        ] })
      ] }, f.id);
    }) }) }),
    /* @__PURE__ */ e.jsx("div", { className: "text-end", children: /* @__PURE__ */ e.jsx(
      W,
      {
        className: "",
        onClick: x,
        type: "button",
        variant: "secondary",
        children: "Add header"
      }
    ) })
  ] });
}, ts = vt(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), _ = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  Nt.Root,
  {
    ref: s,
    className: g(ts(), t),
    ...n
  }
));
_.displayName = Nt.Root.displayName;
const ze = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  Z.Root,
  {
    className: g("grid gap-2", t),
    ...n,
    ref: s
  }
));
ze.displayName = Z.Root.displayName;
const re = b.forwardRef(({ className: t, ...n }, s) => /* @__PURE__ */ e.jsx(
  Z.Item,
  {
    ref: s,
    className: g(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      t
    ),
    ...n,
    children: /* @__PURE__ */ e.jsx(Z.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(Jt, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
re.displayName = Z.Item.displayName;
const Rt = ({
  identities: t,
  setValue: n,
  value: s
}) => /* @__PURE__ */ e.jsx(le, { className: "w-full overflow-hidden", children: /* @__PURE__ */ e.jsxs(
  ze,
  {
    onValueChange: (a) => n(a),
    value: s,
    defaultValue: B,
    className: "gap-0",
    disabled: (t == null ? void 0 : t.length) === 0,
    children: [
      /* @__PURE__ */ e.jsxs(
        _,
        {
          className: "h-12 border-b items-center flex p-4 cursor-pointer hover:bg-accent",
          htmlFor: "none",
          children: [
            /* @__PURE__ */ e.jsx(re, { value: B, id: "none", children: "None" }),
            /* @__PURE__ */ e.jsx(_, { htmlFor: "none", className: "ml-2", children: "None" })
          ]
        }
      ),
      t == null ? void 0 : t.map((a) => /* @__PURE__ */ e.jsxs(
        _,
        {
          className: "h-12 border-b items-center flex p-4 cursor-pointer hover:bg-accent",
          children: [
            /* @__PURE__ */ e.jsx(re, { value: a.id, id: a.id, children: a.label }),
            /* @__PURE__ */ e.jsx(_, { htmlFor: a.id, className: "ml-2", children: a.label })
          ]
        },
        a.id
      ))
    ]
  }
) }), ns = ({
  onSubmit: t,
  identities: n,
  open: s,
  onOpenChange: a
}) => {
  const [r, i] = k(void 0), [l, d] = k(!1);
  return /* @__PURE__ */ e.jsx(Pe, { open: s, onOpenChange: a, children: /* @__PURE__ */ e.jsxs(ke, { children: [
    /* @__PURE__ */ e.jsx(Ie, { children: "Select an auth identity" }),
    /* @__PURE__ */ e.jsx(ft, { children: "Please select an identity for this request." }),
    /* @__PURE__ */ e.jsx("div", { className: "max-h-80 overflow-auto", children: /* @__PURE__ */ e.jsx(
      Rt,
      {
        identities: n,
        setValue: i,
        value: r
      }
    ) }),
    /* @__PURE__ */ e.jsxs(yt, { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            id: "remember",
            checked: l,
            onCheckedChange: (c) => d(
              c === "indeterminate" ? !1 : !!c
            )
          }
        ),
        /* @__PURE__ */ e.jsx(_, { htmlFor: "remember", children: "Remember my choice" })
      ] }),
      /* @__PURE__ */ e.jsx(
        A,
        {
          onClick: () => t({ identity: r, rememberedIdentity: l }),
          children: "Send"
        }
      )
    ] })
  ] }) });
}, ss = ({
  control: t,
  url: n
}) => {
  const { fields: s } = Re({
    control: t,
    name: "pathParams"
  }), a = [...s].sort(
    (r, i) => n.indexOf(`{${r.name}}`) - n.indexOf(`{${i.name}}`)
  );
  return /* @__PURE__ */ e.jsx(le, { className: "rounded-lg", children: /* @__PURE__ */ e.jsx(Ve, { children: a.map((r, i) => /* @__PURE__ */ e.jsxs(Fe, { children: [
    /* @__PURE__ */ e.jsx(
      L,
      {
        control: t,
        name: `pathParams.${i}.name`,
        render: () => /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsx(
          St,
          {
            slug: r.name,
            name: r.name,
            className: "font-mono text-xs px-2"
          }
        ) })
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "flex justify-between items-center", children: /* @__PURE__ */ e.jsx(
      L,
      {
        control: t,
        name: `pathParams.${i}.value`,
        render: ({ field: l }) => /* @__PURE__ */ e.jsx(
          qe,
          {
            ...l,
            required: !0,
            placeholder: "Enter value",
            className: "w-full border-0 shadow-none text-xs font-mono focus-visible:ring-0"
          }
        )
      }
    ) })
  ] }, r.id)) }) });
}, as = De(
  "input",
  "px-2 bg-transparent h-6 font-mono text-xs m-2"
), rs = ({
  control: t,
  queryParams: n
}) => {
  const { fields: s } = Re({
    control: t,
    name: "queryParams"
  }), a = Oe(), r = n.map((i) => !!i.isRequired);
  return /* @__PURE__ */ e.jsx(le, { className: "rounded-lg", children: /* @__PURE__ */ e.jsx("div", { className: "w-full ", children: /* @__PURE__ */ e.jsx(Ve, { children: s.map((i, l) => {
    const d = n.find(
      (c) => c.name === a.watch(`queryParams.${l}.name`)
    );
    return /* @__PURE__ */ e.jsxs(Fe, { children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e.jsx(
          L,
          {
            control: t,
            name: `queryParams.${l}.active`,
            render: ({ field: c }) => /* @__PURE__ */ e.jsx(
              ce,
              {
                id: `queryParams.${l}.active`,
                className: "mr-2",
                checked: c.value,
                onCheckedChange: c.onChange
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          L,
          {
            control: t,
            render: ({ field: c }) => r[l] ? /* @__PURE__ */ e.jsx(as, { asChild: !0, children: /* @__PURE__ */ e.jsxs(
              "label",
              {
                className: "flex items-center cursor-pointer gap-1",
                htmlFor: `queryParams.${l}.active`,
                title: r[l] ? "Required field" : void 0,
                children: [
                  c.value,
                  r[l] && /* @__PURE__ */ e.jsx("sup", { children: " *" })
                ]
              }
            ) }) : /* @__PURE__ */ e.jsx(
              ae,
              {
                value: c.value,
                options: n.map((u) => u.name),
                onChange: (u) => {
                  c.onChange(u);
                },
                className: "border-0 font-mono text-xs bg-transparent hover:bg-transparent"
              }
            ),
            name: `queryParams.${l}.name`
          }
        )
      ] }, i.id),
      /* @__PURE__ */ e.jsx("div", { className: "flex justify-between items-center", children: /* @__PURE__ */ e.jsx(
        L,
        {
          control: t,
          render: ({ field: c }) => (d == null ? void 0 : d.enum) && d.enum.length > 0 ? /* @__PURE__ */ e.jsx(
            ae,
            {
              value: c.value,
              options: d.enum ?? [],
              onChange: (x) => {
                c.onChange(x), a.setValue(`queryParams.${l}.active`, !0);
              },
              className: "font-mono text-xs border-0 ring-1 ring-ring"
            }
          ) : /* @__PURE__ */ e.jsx(
            qe,
            {
              ...c,
              onChange: (x) => {
                c.onChange(x.target.value), x.target.value.length > 0 && a.setValue(`queryParams.${l}.active`, !0);
              },
              placeholder: "Enter value",
              className: "w-full border-0 shadow-none focus-visible:ring-0 text-xs font-mono"
            }
          ),
          name: `queryParams.${l}.value`
        }
      ) })
    ] }, i.id);
  }) }) }) });
}, os = xt()(
  gt(
    (t, n) => ({
      rememberedIdentity: null,
      setRememberedIdentity: (s) => t({ rememberedIdentity: s }),
      getRememberedIdentity: (s) => s.find(
        (a) => a === n().rememberedIdentity
      )
    }),
    {
      name: "identity-storage",
      storage: Xt(() => sessionStorage)
    }
  )
), is = ({
  open: t,
  setOpen: n,
  onSignUp: s,
  onLogin: a
}) => /* @__PURE__ */ e.jsx(Pe, { open: t, onOpenChange: n, children: /* @__PURE__ */ e.jsxs(ke, { children: [
  /* @__PURE__ */ e.jsx(Ie, { children: "Welcome to the Playground!" }),
  /* @__PURE__ */ e.jsx(ft, { children: "The Playground is a tool for developers to test and explore our APIs. To use the Playground, you need to login." }),
  /* @__PURE__ */ e.jsxs(yt, { className: "flex gap-2 sm:justify-between", children: [
    /* @__PURE__ */ e.jsx(A, { type: "button", variant: "ghost", onClick: () => n(!1), children: "Skip" }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2", children: [
      s && /* @__PURE__ */ e.jsx(A, { type: "button", variant: "outline", onClick: s, children: "Sign Up" }),
      a && /* @__PURE__ */ e.jsx(A, { type: "button", variant: "default", onClick: a, children: "Login" })
    ] })
  ] })
] }) }), I = {
  green: "text-green-600",
  blue: "text-sky-600",
  yellow: "text-yellow-600",
  red: "text-red-600",
  purple: "text-purple-600",
  indigo: "text-indigo-600",
  gray: "text-gray-600"
}, ls = {
  get: I.green,
  post: I.blue,
  put: I.yellow,
  delete: I.red,
  patch: I.purple,
  options: I.indigo,
  head: I.gray,
  trace: I.gray
}, cs = (t) => ls[t.toLocaleLowerCase()] ?? I.gray, ds = ({
  method: t,
  url: n,
  headers: s,
  body: a
}) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 font-mono text-xs", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "gap-2 p-2 bg-muted rounded-md", children: [
    /* @__PURE__ */ e.jsx("span", { className: g(cs(t), "font-semibold"), children: t }),
    " ",
    /* @__PURE__ */ e.jsx("span", { className: "break-all", children: n }),
    " ",
    /* @__PURE__ */ e.jsx("span", { className: "text-muted-foreground", children: "HTTP/1.1" })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "mx-1.5 flex flex-col gap-3", children: [
    /* @__PURE__ */ e.jsxs(at, { defaultOpen: !0, children: [
      /* @__PURE__ */ e.jsxs(rt, { className: "flex items-center gap-2 hover:text-primary group", children: [
        /* @__PURE__ */ e.jsx(Q, { className: "h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-[90deg]" }),
        /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Headers" })
      ] }),
      /* @__PURE__ */ e.jsx(ot, { children: /* @__PURE__ */ e.jsx("div", { className: "grid grid-cols-[auto,1fr] gap-x-8 gap-y-1 pl-1.5 pt-2", children: s.map(([r, i]) => /* @__PURE__ */ e.jsxs(q, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "text-primary", children: r }),
        /* @__PURE__ */ e.jsx("div", { className: "break-all", children: i })
      ] }, r)) }) })
    ] }),
    /* @__PURE__ */ e.jsxs(at, { defaultOpen: !0, children: [
      /* @__PURE__ */ e.jsxs(rt, { className: "flex items-center gap-2 hover:text-primary group", children: [
        /* @__PURE__ */ e.jsx(Q, { className: "h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-[90deg]" }),
        /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Body" })
      ] }),
      /* @__PURE__ */ e.jsx(ot, { children: /* @__PURE__ */ e.jsx("div", { className: "pl-0 pt-2", children: /* @__PURE__ */ e.jsx(
        "div",
        {
          className: g(
            "whitespace-pre-wrap break-all bg-muted p-2 rounded-md",
            !a && "text-muted-foreground"
          ),
          children: a ?? "Empty body"
        }
      ) }) })
    ] })
  ] })
] }), lt = Le.Root, ct = Le.CollapsibleTrigger, dt = Le.CollapsibleContent;
function Me(t) {
  if (t === null) return "null";
  if (Array.isArray(t)) {
    if (t.length === 0) return "any[]";
    const n = t[0];
    return n === void 0 ? "any[]" : `${Me(n)}[]`;
  }
  return typeof t == "object" ? ms(t) : typeof t;
}
function ms(t, n = "") {
  const s = ["{"];
  for (const [a, r] of Object.entries(t)) {
    const i = Me(r);
    s.push(`  ${a}: ${i};`);
  }
  return s.push("}"), s.join(`
`);
}
function us(t) {
  return { lines: [`type GeneratedType = ${Me(t)};`] };
}
const ps = {
  200: "OK",
  201: "Created",
  202: "Accepted",
  204: "No Content",
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  500: "Internal Server Error"
}, mt = (t) => {
  const n = Math.floor(Math.log(t) / Math.log(1e3));
  return `${(t / Math.pow(1e3, n)).toFixed(
    n ? 2 : 0
  )} ${n ? `${"kMGTPEZY"[n - 1]}B` : "B"}`;
}, hs = (t) => {
  var s;
  return (s = Object.entries({
    "application/json": "json",
    "text/json": "json",
    "text/html": "html",
    "text/css": "css",
    "text/javascript": "javascript",
    "application/xml": "xml",
    "application/xhtml+xml": "xhtml"
  }).find(
    ([a]) => t.includes(a)
  )) == null ? void 0 : s[1];
}, xs = (t) => {
  var s;
  const n = ((s = t.find(([a, r]) => a === "Content-Type")) == null ? void 0 : s[1]) || "";
  return hs(n);
}, gs = (t) => {
  try {
    return JSON.stringify(JSON.parse(t), null, 2);
  } catch {
    return null;
  }
}, fs = (t) => {
  const n = [
    "Content-Type",
    "Content-Length",
    "Authorization",
    "X-RateLimit-Remaining",
    "X-RateLimit-Limit",
    "Cache-Control",
    "ETag"
  ].map((s) => s.toLowerCase());
  return [...t].sort(([s], [a]) => {
    const r = n.indexOf(s.toLowerCase()), i = n.indexOf(a.toLowerCase());
    return r === i ? 0 : r === -1 ? 1 : i === -1 ? -1 : r - i;
  });
}, ut = 64e3, ys = ({
  body: t = "",
  headers: n,
  status: s,
  time: a,
  size: r,
  url: i
}) => {
  var f;
  const l = xs(n), d = gs(t), c = d || t, [u, x] = k(
    d ? "formatted" : "raw"
  ), w = Kt({
    queryKey: ["types", c],
    queryFn: async () => us(JSON.parse(c)),
    enabled: u === "types"
  }), v = fs([...n]), p = r > ut;
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 h-full overflow-auto max-h-[calc(100vh-220px)] ", children: [
    /* @__PURE__ */ e.jsxs(lt, { defaultOpen: !0, children: [
      /* @__PURE__ */ e.jsxs(ct, { className: "flex items-center gap-2 hover:text-primary group", children: [
        /* @__PURE__ */ e.jsx(Q, { className: "h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-[90deg]" }),
        /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Headers" })
      ] }),
      /* @__PURE__ */ e.jsx(dt, { children: /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-[auto,1fr] gap-x-8 gap-y-1 pl-1.5 pt-2 font-mono text-xs", children: [
        v.slice(0, 5).map(([m, y]) => /* @__PURE__ */ e.jsxs(q, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "text-primary whitespace-pre", children: m }),
          /* @__PURE__ */ e.jsx("div", { className: "break-all", children: y })
        ] }, m)),
        v.length > 5 && /* @__PURE__ */ e.jsxs(lt, { className: "col-span-full grid-cols-subgrid grid", children: [
          /* @__PURE__ */ e.jsxs(ct, { className: "col-span-2 text-xs text-muted-foreground hover:text-primary flex items-center gap-1 py-1", children: [
            /* @__PURE__ */ e.jsx(Q, { className: "h-3 w-3 transition-transform duration-200 group-data-[state=open]:rotate-[90deg]" }),
            "Show ",
            v.length - 5,
            " more headers"
          ] }),
          /* @__PURE__ */ e.jsx(dt, { className: "col-span-full grid grid-cols-subgrid gap-x-8 gap-y-1 ", children: v.slice(5).map(([m, y]) => /* @__PURE__ */ e.jsxs(q, { children: [
            /* @__PURE__ */ e.jsx("div", { className: "text-primary whitespace-pre", children: m }),
            /* @__PURE__ */ e.jsx("div", { className: "break-all", children: y })
          ] }, m)) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ e.jsxs(wt, { className: "shadow-none", children: [
      p && /* @__PURE__ */ e.jsxs(jn, { type: "info", className: "my-0 p-2", children: [
        "Code highlight is disabled for responses larger than",
        " ",
        mt(ut)
      ] }),
      /* @__PURE__ */ e.jsx(
        $n,
        {
          language: u === "types" ? "typescript" : u === "raw" ? d ? "plain" : l : "json",
          showCopy: "always",
          disabled: p,
          noBackground: !0,
          className: "overflow-x-auto p-4 text-xs max-h-[calc(83.333vh-180px)]",
          code: (u === "raw" ? t : u === "types" ? (f = w.data) == null ? void 0 : f.lines.join(`
`) : c) ?? ""
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2 justify-between items-center", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex text-xs gap-2 border bg-muted rounded-md p-2 items-center h-8 font-mono divide-x", children: [
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("span", { className: "text-muted-foreground", children: "Status" }),
          " ",
          s,
          " ",
          ps[s] ?? ""
        ] }),
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("span", { className: "text-muted-foreground", children: "Time" }),
          " ",
          a.toFixed(0),
          "ms"
        ] }),
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("span", { className: "text-muted-foreground", children: "Size" }),
          " ",
          mt(r)
        ] })
      ] }),
      d && /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(
        je,
        {
          value: u,
          onValueChange: (m) => x(m),
          children: [
            /* @__PURE__ */ e.jsx(be, { className: "min-w-32", children: /* @__PURE__ */ e.jsx(Ne, { placeholder: "View" }) }),
            /* @__PURE__ */ e.jsxs(we, { children: [
              /* @__PURE__ */ e.jsx(U, { value: "formatted", children: "Formatted" }),
              /* @__PURE__ */ e.jsx(U, { value: "raw", children: "Raw" }),
              /* @__PURE__ */ e.jsx(U, { value: "types", children: "Types" })
            ] })
          ]
        }
      ) })
    ] })
  ] });
}, vs = ({
  queryMutation: t,
  showPathParamsWarning: n,
  showLongRunningWarning: s,
  onCancel: a
}) => {
  var i;
  const r = ((((i = t.data) == null ? void 0 : i.status) ?? 0) / 100).toFixed(0);
  return /* @__PURE__ */ e.jsx("div", { className: "min-w-0 p-4 py-8 bg-muted/50", children: t.error ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    n && /* @__PURE__ */ e.jsx(wn, { type: "caution", children: "Some path parameters are missing values. Please fill them in to ensure the request is sent correctly." }),
    /* @__PURE__ */ e.jsxs(wt, { children: [
      /* @__PURE__ */ e.jsx(Cn, { children: /* @__PURE__ */ e.jsx(Sn, { children: "Request failed" }) }),
      /* @__PURE__ */ e.jsxs(Tn, { children: [
        "Error:",
        " ",
        t.error.message || String(t.error) || "Unexpected error"
      ] })
    ] })
  ] }) : t.data ? /* @__PURE__ */ e.jsxs(jt, { defaultValue: "response", children: [
    /* @__PURE__ */ e.jsxs(bt, { children: [
      /* @__PURE__ */ e.jsx(M, { value: "request", children: "Request" }),
      /* @__PURE__ */ e.jsxs(M, { value: "response", children: [
        "Response",
        /* @__PURE__ */ e.jsxs(
          "span",
          {
            className: g(
              "text-xs font-mono ml-1",
              r === "2" && "text-green-500",
              r === "3" && "text-blue-500",
              r === "4" && "text-yellow-500",
              r === "5" && "text-red-500"
            ),
            children: [
              "(",
              t.data.status,
              ")"
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(H, { value: "request", children: /* @__PURE__ */ e.jsx(ds, { ...t.data.request }) }),
    /* @__PURE__ */ e.jsx(H, { value: "response", children: /* @__PURE__ */ e.jsx(
      ys,
      {
        status: t.data.status,
        time: t.data.time,
        size: t.data.size,
        headers: t.data.headers,
        body: t.data.body,
        url: t.data.request.url
      }
    ) })
  ] }) : /* @__PURE__ */ e.jsx("div", { className: "grid place-items-center h-full", children: t.isPending ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 items-center mt-20", children: [
    /* @__PURE__ */ e.jsx(Nn, { size: 20 }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: g(
          "opacity-0 pointer-events-none transition-opacity h-20 text-sm text-muted-foreground duration-300 flex flex-col gap-2 items-center",
          s && "opacity-100 pointer-events-auto"
        ),
        children: [
          "Looks like the request is taking longer than expected.",
          /* @__PURE__ */ e.jsx(
            W,
            {
              type: "button",
              onClick: a,
              size: "sm",
              className: "w-fit",
              variant: "outline",
              children: "Cancel"
            }
          )
        ]
      }
    )
  ] }) : /* @__PURE__ */ e.jsx("span", { className: "text-[16px] font-semibold text-muted-foreground", children: "Send a request first to see the response here" }) }) });
}, js = ({
  identities: t,
  formRef: n,
  disabled: s
}) => {
  const { setValue: a } = Oe(), [r, i] = k();
  return t.length === 0 ? /* @__PURE__ */ e.jsx(A, { disabled: s, children: "Send" }) : /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
    /* @__PURE__ */ e.jsx(
      A,
      {
        className: "rounded-r-none inset-shadow-sm",
        disabled: s,
        onClick: () => {
          var l;
          return (l = n == null ? void 0 : n.current) == null ? void 0 : l.requestSubmit();
        },
        children: "Send"
      }
    ),
    /* @__PURE__ */ e.jsxs(Tt, { children: [
      /* @__PURE__ */ e.jsx($t, { asChild: !0, children: /* @__PURE__ */ e.jsx(
        A,
        {
          disabled: s,
          className: "rounded-l-none border-l border-border/40 inset-shadow-sm w-6",
          size: "icon",
          children: /* @__PURE__ */ e.jsx(Ut, { className: "w-4 h-4" })
        }
      ) }),
      /* @__PURE__ */ e.jsx(ze, { value: r, children: /* @__PURE__ */ e.jsx(Ae, { className: "w-56", align: "end", alignOffset: -150, children: [{ id: B, label: "None" }, ...t].map(
        (l) => /* @__PURE__ */ e.jsxs(
          Ee,
          {
            onClick: () => {
              var d;
              i(l.id), a("identity", l.id), (d = n == null ? void 0 : n.current) == null || d.requestSubmit();
            },
            onMouseEnter: () => i(l.id),
            onMouseLeave: () => i(void 0),
            children: [
              /* @__PURE__ */ e.jsx(re, { value: l.id, className: "mr-2" }),
              l.label
            ]
          },
          l.id
        )
      ) }) })
    ] })
  ] });
}, B = "__none", ve = {
  Plain: "text/plain",
  JSON: "application/json",
  XML: "application/xml",
  YAML: "application/yaml",
  CSV: "text/csv"
}, bs = ({
  server: t,
  servers: n = [],
  url: s,
  method: a,
  headers: r = [],
  queryParams: i = [],
  pathParams: l = [],
  defaultBody: d = "",
  examples: c,
  requiresLogin: u = !1,
  onLogin: x,
  onSignUp: w
}) => {
  var Ze, Xe;
  const { selectedServer: v, setSelectedServer: p } = _n(
    n.map((o) => ({ url: o }))
  ), [f, m] = k(!1), y = Yt(), { setRememberedIdentity: h, getRememberedIdentity: T } = os(), [, $] = rn(), [de, X] = k(!1), [K, E] = k(!1), Y = G(void 0), Be = un(h), { register: Ge, control: ee, handleSubmit: Je, watch: Ue, setValue: V, ...me } = cn({
    defaultValues: {
      body: d,
      bodyContentType: "JSON",
      queryParams: i.map((o) => ({
        name: o.name,
        value: o.defaultValue ?? "",
        active: o.defaultActive ?? !1,
        enum: o.enum ?? []
      })).concat([
        {
          name: "",
          value: "",
          active: !1,
          enum: []
        }
      ]),
      pathParams: l.map((o) => ({
        name: o.name,
        value: o.defaultValue ?? ""
      })),
      headers: r.map((o) => ({
        name: o.name,
        value: o.defaultValue ?? "",
        active: o.defaultActive ?? !1
      })).concat([
        {
          name: "",
          value: "",
          active: !1
        }
      ]),
      identity: T(
        ((Ze = y.data) == null ? void 0 : Ze.map((o) => o.id)) ?? []
      )
    }
  }), C = Ue(), Qe = G(null);
  ne(() => {
    C.identity && Be.current(C.identity);
  }, [Be, C.identity]);
  const ue = ln({
    mutationFn: async (o) => {
      var Ke, Ye;
      const S = performance.now(), O = !o.headers.some(
        (N) => N.active && N.name.toLowerCase() === "content-type"
      ), F = Object.fromEntries([
        ...o.headers.filter((N) => N.name && N.active).map((N) => [N.name, N.value]),
        ...O ? [["content-type", ve[o.bodyContentType]]] : []
      ]), P = new Request(
        Bn(t ?? v, s, o),
        {
          method: a.toUpperCase(),
          headers: F,
          body: o.body ? o.body : void 0
        }
      );
      o.identity !== B && await ((Ye = (Ke = y.data) == null ? void 0 : Ke.find((N) => N.id === o.identity)) == null ? void 0 : Ye.authorizeRequest(P));
      const z = setTimeout(
        () => E(!0),
        3210
      );
      Y.current = new AbortController();
      try {
        const N = await fetch(P, {
          signal: Y.current.signal
        });
        clearTimeout(z), E(!1);
        const Dt = performance.now() - S, et = await N.text(), Vt = new URL(P.url);
        return {
          status: N.status,
          headers: Array.from(N.headers.entries()),
          size: et.length,
          body: et,
          time: Dt,
          request: {
            method: P.method.toUpperCase(),
            url: P.url,
            headers: [
              ["Host", Vt.host],
              ["User-Agent", "Zudoku Playground"],
              ...Array.from(P.headers.entries())
            ],
            body: o.body ? o.body : void 0
          }
        };
      } catch (N) {
        throw clearTimeout(z), E(!1), N instanceof TypeError ? new Error(
          "The request failed, possibly due to network issues or CORS policy."
        ) : N;
      }
    }
  });
  ne(() => () => {
    var o;
    (o = Y.current) == null || o.abort();
  }, []);
  const Lt = /* @__PURE__ */ e.jsx(
    zn,
    {
      path: s,
      renderParam: ({ name: o, originalValue: S, index: O }) => {
        var P;
        const F = (P = C.pathParams.find(
          (z) => z.name === o
        )) == null ? void 0 : P.value;
        return /* @__PURE__ */ e.jsx(
          St,
          {
            name: o,
            backgroundOpacity: "0",
            slug: o,
            onClick: () => me.setFocus(`pathParams.${O}.value`),
            children: F || S
          }
        );
      }
    }
  ), We = C.queryParams.filter((o) => o.active).map((o, S, O) => /* @__PURE__ */ e.jsxs(q, { children: [
    o.name,
    "=",
    encodeURIComponent(o.value).replaceAll("%20", "+"),
    S < O.length - 1 && "&",
    /* @__PURE__ */ e.jsx("wbr", {})
  ] }, o.name)), At = /* @__PURE__ */ e.jsx("div", { className: "inline-block opacity-50 hover:opacity-100 transition", children: t ? /* @__PURE__ */ e.jsx("span", { children: t.replace(/^https?:\/\//, "").replace(/\/$/, "") }) : n.length > 1 && /* @__PURE__ */ e.jsxs(
    je,
    {
      onValueChange: (o) => {
        $(() => p(o));
      },
      value: v,
      defaultValue: v,
      children: [
        /* @__PURE__ */ e.jsx(be, { className: "p-0 border-none flex-row-reverse bg-transparent text-xs gap-0.5 h-auto translate-y-[4px]", children: /* @__PURE__ */ e.jsx(Ne, {}) }),
        /* @__PURE__ */ e.jsx(we, { children: n.map((o) => /* @__PURE__ */ e.jsx(U, { value: o, children: o.replace(/^https?:\/\//, "").replace(/\/$/, "") }, o)) })
      ]
    }
  ) }), Et = u && !de, te = ["POST", "PUT", "PATCH", "DELETE"].includes(
    a.toUpperCase()
  );
  return /* @__PURE__ */ e.jsx(
    dn,
    {
      register: Ge,
      control: ee,
      handleSubmit: Je,
      watch: Ue,
      setValue: V,
      ...me,
      children: /* @__PURE__ */ e.jsxs(
        "form",
        {
          onSubmit: Je((o) => {
            var S;
            ((S = y.data) == null ? void 0 : S.length) === 0 || o.identity ? ue.mutate(o) : m(!0);
          }),
          ref: Qe,
          className: "relative",
          children: [
            /* @__PURE__ */ e.jsx(
              ns,
              {
                identities: y.data ?? [],
                open: f,
                onOpenChange: m,
                onSubmit: ({ rememberedIdentity: o, identity: S }) => {
                  o && V("identity", S ?? B), m(!1), ue.mutate({ ...C, identity: S });
                }
              }
            ),
            /* @__PURE__ */ e.jsx(
              is,
              {
                open: Et,
                setOpen: (o) => X(!o),
                onSignUp: w,
                onLogin: x
              }
            ),
            /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-2 text-sm h-full", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 p-4 after:bg-muted-foreground/20 relative after:absolute after:w-px after:inset-0 after:left-auto", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2 items-stretch", children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 items-center w-full border rounded-md", children: [
                    /* @__PURE__ */ e.jsx("div", { className: "border-r p-2 bg-muted rounded-l-md self-stretch font-semibold font-mono flex items-center", children: a.toUpperCase() }),
                    /* @__PURE__ */ e.jsxs("div", { className: "items-center px-2 py-0.5 font-mono text-xs break-all leading-6", children: [
                      At,
                      Lt,
                      We.length > 0 ? "?" : "",
                      We
                    ] })
                  ] }),
                  /* @__PURE__ */ e.jsx(
                    js,
                    {
                      identities: y.data ?? [],
                      formRef: Qe,
                      disabled: y.isLoading || me.formState.isSubmitting
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsxs(jt, { defaultValue: "parameters", children: [
                  /* @__PURE__ */ e.jsx("div", { className: "flex flex-wrap gap-1 justify-between", children: /* @__PURE__ */ e.jsxs(bt, { children: [
                    /* @__PURE__ */ e.jsxs(M, { value: "parameters", children: [
                      "Parameters",
                      (C.pathParams.some((o) => o.value !== "") || C.queryParams.some((o) => o.active)) && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
                    ] }),
                    /* @__PURE__ */ e.jsxs(M, { value: "headers", children: [
                      "Headers",
                      C.headers.filter((o) => o.active).length > 0 && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
                    ] }),
                    /* @__PURE__ */ e.jsxs(M, { value: "auth", children: [
                      "Auth",
                      C.identity !== B && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
                    ] }),
                    /* @__PURE__ */ e.jsxs(M, { value: "body", children: [
                      "Body",
                      C.body && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ e.jsx(H, { value: "headers", children: /* @__PURE__ */ e.jsx(es, { control: ee, headers: r }) }),
                  /* @__PURE__ */ e.jsxs(H, { value: "parameters", children: [
                    l.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                      /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Path Parameters" }),
                      /* @__PURE__ */ e.jsx(ss, { url: s, control: ee })
                    ] }),
                    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                      /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Query Parameters" }),
                      /* @__PURE__ */ e.jsx(rs, { control: ee, queryParams: i })
                    ] })
                  ] }),
                  /* @__PURE__ */ e.jsxs(H, { value: "body", children: [
                    !["POST", "PUT", "PATCH", "DELETE"].includes(
                      a.toUpperCase()
                    ) && /* @__PURE__ */ e.jsxs(Se, { className: "mb-2", children: [
                      /* @__PURE__ */ e.jsx(nt, { className: "w-4 h-4" }),
                      /* @__PURE__ */ e.jsx(Te, { children: "Body" }),
                      /* @__PURE__ */ e.jsx($e, { children: "Body is only supported for POST, PUT, PATCH, and DELETE requests" })
                    ] }),
                    /* @__PURE__ */ e.jsx(
                      Ct,
                      {
                        ...Ge("body"),
                        className: g(
                          "border w-full rounded-lg bg-muted/40 p-2 h-64 font-mono text-[13px]",
                          !te && "h-20 bg-muted"
                        ),
                        placeholder: te ? void 0 : "This request does not support a body",
                        disabled: !te
                      }
                    ),
                    te && /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2 mt-2 justify-between", children: [
                      /* @__PURE__ */ e.jsxs(
                        je,
                        {
                          value: C.bodyContentType,
                          onValueChange: (o) => V(
                            "bodyContentType",
                            o
                          ),
                          children: [
                            /* @__PURE__ */ e.jsx(be, { className: "w-[100px]", children: /* @__PURE__ */ e.jsx(Ne, {}) }),
                            /* @__PURE__ */ e.jsx(we, { children: Object.keys(ve).map((o) => /* @__PURE__ */ e.jsx(U, { value: o, children: o }, o)) })
                          ]
                        }
                      ),
                      c && c.length > 0 && /* @__PURE__ */ e.jsx(
                        Zn,
                        {
                          examples: c,
                          onSelect: (o, S) => {
                            var F;
                            V(
                              "body",
                              JSON.stringify(o.value, null, 2)
                            );
                            const O = (F = mn(ve).find(
                              ([P, z]) => z === S
                            )) == null ? void 0 : F[0];
                            O && V("bodyContentType", O);
                          }
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ e.jsx(H, { value: "auth", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                    ((Xe = y.data) == null ? void 0 : Xe.length) === 0 && /* @__PURE__ */ e.jsxs(Se, { children: [
                      /* @__PURE__ */ e.jsx(nt, { className: "w-4 h-4" }),
                      /* @__PURE__ */ e.jsx(Te, { children: "Authentication" }),
                      /* @__PURE__ */ e.jsx($e, { children: "No identities found. Please create an identity first." })
                    ] }),
                    /* @__PURE__ */ e.jsx("div", { className: "flex flex-col items-center gap-2", children: /* @__PURE__ */ e.jsx(
                      Rt,
                      {
                        value: C.identity,
                        identities: y.data ?? [],
                        setValue: (o) => V("identity", o)
                      }
                    ) })
                  ] }) })
                ] })
              ] }),
              /* @__PURE__ */ e.jsx(
                vs,
                {
                  queryMutation: ue,
                  showPathParamsWarning: C.pathParams.some(
                    (o) => o.value === ""
                  ),
                  showLongRunningWarning: K,
                  onCancel: () => {
                    var o;
                    (o = Y.current) == null || o.abort(
                      "Request cancelled by the user"
                    ), E(!1);
                  }
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, Ns = ({
  className: t,
  size: n = 16
}) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: t,
    width: n,
    height: n,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
      }
    )
  }
), ws = (t) => {
  const [n, s] = k(!1);
  return /* @__PURE__ */ e.jsxs(Pe, { onOpenChange: (a) => s(a), children: [
    /* @__PURE__ */ e.jsx(on, { asChild: !0, children: t.children ?? /* @__PURE__ */ e.jsxs(
      "button",
      {
        type: "button",
        className: "flex gap-1 items-center px-2 py-1 rounded-md transition text-xs bg-primary  text-primary-foreground shadow-sm hover:bg-primary/80",
        children: [
          "Test",
          /* @__PURE__ */ e.jsx(Ns, { size: 14 })
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsxs(
      ke,
      {
        className: "max-w-screen-xl w-full h-5/6 overflow-hidden p-0",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ e.jsx(nn, { children: /* @__PURE__ */ e.jsx(Ie, { children: "Playground" }) }),
          n && /* @__PURE__ */ e.jsx(bs, { ...t })
        ]
      }
    )
  ] });
}, Cs = {
  get: "green",
  post: "blue",
  put: "yellow",
  delete: "red",
  patch: "purple",
  options: "gray",
  head: "gray"
}, pt = ({
  label: t,
  path: n,
  operations: s,
  collapsible: a,
  collapsed: r
}) => ({
  type: "category",
  label: t,
  link: {
    type: "doc",
    id: n,
    label: t
  },
  collapsible: a,
  collapsed: r,
  items: s.map((i) => ({
    type: "link",
    label: i.summary ?? i.path,
    href: `${n}#${i.slug}`,
    badge: {
      label: i.method,
      color: Cs[i.method.toLowerCase()],
      invert: !0
    }
  }))
}), ht = (t) => ({
  path: t.routePath,
  async lazy() {
    const { OasProvider: n } = await import("./OasProvider-CDtbrUG_.js");
    return {
      element: /* @__PURE__ */ e.jsx(
        n,
        {
          basePath: t.basePath,
          version: t.version,
          client: t.client,
          config: t.config
        }
      )
    };
  },
  children: t.routes
}), He = ({
  path: t,
  tag: n,
  untagged: s
}) => ({
  path: t,
  async lazy() {
    const { OperationList: a } = await import("./OperationList-DTyJIxKW.js");
    return { element: /* @__PURE__ */ e.jsx(a, { tag: n, untagged: s }) };
  }
}), Ot = (t) => [
  // Category without tagged operations
  He({
    path: R(t, _e),
    untagged: !0
  }),
  // Schema list route
  {
    path: R(t, "~schemas"),
    lazy: async () => {
      const { SchemaList: n } = await import("./SchemaList-B9lvArDe.js");
      return { element: /* @__PURE__ */ e.jsx(n, {}) };
    }
  }
], Ss = (t, n) => {
  const s = R(t, n.at(0) ?? _e);
  return [
    // Redirect to first tag on the index route
    { index: !0, loader: () => Zt(s) },
    // Create routes for each tag
    ...n.map(
      (a) => He({
        path: R(t, a),
        tag: a
      })
    ),
    ...Ot(t)
  ];
}, qt = (t) => t.type === "file" ? Object.keys(t.input) : [], Ts = ({
  basePath: t,
  config: n,
  client: s
}) => {
  const a = n.tagPages;
  if (!a)
    return [
      ht({
        basePath: t,
        routePath: t,
        routes: [
          He({ path: t + "/:tag?" }),
          ...Ot(t)
        ],
        client: s,
        config: n
      })
    ];
  const r = qt(n);
  return (r.length > 1 ? [void 0, ...r] : [void 0]).map((l) => {
    const d = R(t, l);
    return ht({
      basePath: t,
      version: l,
      routePath: d,
      routes: Ss(d, a),
      client: s,
      config: n
    });
  });
}, $s = Vn(`
  query GetSidebarOperations($input: JSON!, $type: SchemaType!) {
    schema(input: $input, type: $type) {
      tags {
        slug
        name
        extensions
        operations {
          summary
          slug
          method
          operationId
          path
        }
      }
      components {
        schemas {
          __typename
        }
      }
    }
  }
`), _e = "~endpoints", aa = (t) => {
  const n = R(t.navigationId ?? "/reference"), s = new kn(t);
  return {
    getHead: () => {
      if (t.type === "url" && !t.skipPreload)
        return /* @__PURE__ */ e.jsx(
          "link",
          {
            rel: "preload",
            href: t.input,
            as: "fetch",
            crossOrigin: "anonymous"
          }
        );
      if (t.server)
        return /* @__PURE__ */ e.jsx("link", { rel: "preconnect", href: t.server });
    },
    getMdxComponents: () => ({
      OpenPlaygroundButton: ({
        requireAuth: a,
        server: r,
        method: i,
        url: l,
        children: d,
        ...c
      }) => {
        const u = en();
        if (!r)
          throw new Error("Server is required");
        return a && !u.isAuthenticated ? /* @__PURE__ */ e.jsxs(
          W,
          {
            className: "gap-2 items-center",
            variant: "outline",
            onClick: u.login,
            children: [
              "Login to open in Playground ",
              /* @__PURE__ */ e.jsx(Qt, { size: 16 })
            ]
          }
        ) : /* @__PURE__ */ e.jsx(
          ws,
          {
            url: l ?? "/",
            method: i ?? "get",
            server: r,
            ...c,
            children: /* @__PURE__ */ e.jsx(W, { className: "gap-2 items-center", variant: "outline", children: d ?? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              "Open in Playground ",
              /* @__PURE__ */ e.jsx(Wt, { size: 16 })
            ] }) })
          }
        );
      }
    }),
    getSidebar: async (a, r) => {
      var l, d, c, u;
      if (!st({ path: n, end: !1 }, a))
        return [];
      const i = st(
        { path: `${n}/:version?/:tag`, end: !0 },
        a
      );
      try {
        const x = i == null ? void 0 : i.params.version, w = x ?? qt(t).at(0), { type: v } = t, p = v === "file" ? t.input[w] : t.input, f = await r.queryClient.ensureQueryData({
          queryKey: ["sidebar-operations-query", p],
          queryFn: () => s.fetch($s, { type: v, input: p })
        }), m = f.schema.tags.flatMap((h) => {
          var X, K, E;
          if (!h.name || h.operations.length === 0) return [];
          const T = R(n, x, h.slug), $ = ((X = h.extensions) == null ? void 0 : X["x-zudoku-collapsed"]) ?? !((K = t.options) != null && K.expandAllTags), de = ((E = h.extensions) == null ? void 0 : E["x-zudoku-collapsible"]) ?? !0;
          return pt({
            label: h.name,
            path: T,
            operations: h.operations,
            collapsed: $,
            collapsible: de
          });
        }), y = (l = f.schema.tags.find(
          (h) => !h.name
        )) == null ? void 0 : l.operations;
        return y && m.push(
          pt({
            label: "Other endpoints",
            path: R(n, x, _e),
            operations: y,
            collapsed: !((d = t.options) != null && d.expandAllTags)
          })
        ), (u = (c = f.schema.components) == null ? void 0 : c.schemas) != null && u.length && m.push({
          type: "link",
          label: "Schemas",
          href: R(n, x, "~schemas")
        }), m;
      } catch {
        return [];
      }
    },
    getRoutes: () => Ts({ basePath: n, config: t, client: s })
  };
};
export {
  lt as C,
  ws as P,
  _e as U,
  ct as a,
  dt as b,
  Vn as c,
  St as d,
  zn as e,
  qt as g,
  cs as m,
  aa as o,
  _n as u
};
//# sourceMappingURL=index-Ckl3s_w-.js.map
